// extracted by mini-css-extract-plugin
module.exports = {"contain":"Portfolio_contain__2zJiO","name":"Portfolio_name__3ONun","desc":"Portfolio_desc__1GoZ9","typebox":"Portfolio_typebox__ChkBK","badge":"Portfolio_badge__YiyFQ"};